module.exports = __webpack_public_path__ + "static/img/hsbc.2c93ec97.svg";